import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { VW_ROUTES } from "../../constants";

const ProfileNotFound = () => {
  const history = useHistory();

  const handleRoute = () => {
    history.replace({
      pathname: VW_ROUTES.DASHBOARD,
    });
  };

  return (
    <main className={`login-cover`}>
      <div className="maintenance-section">
        <div className="card content-portion">
          <div className="content-inner not-found">
            <div>
              <div style={{ fontSize: "7rem" }}> 404</div>
              <div className="card-body">
                <h5 className="card-title message-title">Resource Not Found</h5>
                <p className="card-text message">
                  We are sorry for the inconvenience, The resource you are
                  trying to access could not be found on this server!
                </p>
              </div>
            </div>
            <button
              className="btn btn-secondary mb-1 mt-5"
              onClick={handleRoute}
            >
              Go To Dashboard
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ProfileNotFound;
